var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTurnUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.677l-1.252.21a10.509 10.509 0 00-8.606 8.624 13.457 13.457 0 018.235-3.723l1.623-.134v4.197l7.27-6.61-7.27-6.609v4.045zM3.52 19.884a11.697 11.697 0 00-.534.743c-.26.392-.878.296-.925-.172A12.098 12.098 0 012 19.24C2 13.295 6.325 8.36 12 7.407V3.502c0-.868 1.03-1.324 1.673-.74l8.513 7.74a1 1 0 010 1.48l-8.513 7.739c-.643.584-1.673.128-1.673-.74v-3.699a12 12 0 00-8.48 4.602z",
    fill: "currentColor"
  })));
}
export default SvgArrowTurnUpRight;